<template>
  <div class="PageTitle"
       style="margin: -12px -12px 16px -12px;">
    <div class="d-flex justify-space-between align-center pa-4">
      <div class="text-h4 d-flex align-center"
           :class="$root.isAdminRoute ? 'font-weight-bold' : ''">
        <slot name="icon">
          <v-icon v-if="icon"
                  left
                  color="#36405a">
            {{ icon }}
          </v-icon>
        </slot>
        <slot></slot>
      </div>
      <div class="d-flex justify-space-between align-center">
        <slot name="buttons">
        </slot>
      </div>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      required: false,
    },
  }
}
</script>
